// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"985ef66f","303":"91177237","571":"06231569","615":"d529c32b","675":"77661280","698":"5210f5b1","708":"47914da8","774":"85b0b46a","807":"74648793","836":"a166dc3d","854":"d990c5ca"}[chunkId] + ".chunk.js";
};